export default function checkIsExternal(slug: string) {
	const regex = new RegExp(/^(?:https?:\/\/[\w-]+(?:\.[\w-]+)+[\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])$/gm);
	return regex.test(slug);
}
